import angular from 'angular';
import brandingUploads from './brandingUploads';

export default angular
  .module('components.brandingUploads', [])
  .component('brandingUploads', brandingUploads).name;
